import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { getTarjeta } from '../../components/DeclaracionRenta/EmpresarioIndividual/registry';
import { useAuth } from '../../context/AuthContext';
import '../../styles/components/TarjetaEmpresarioIndividual.css';

/**
 * Página de una tarjeta de fuente de datos del panel del empresario individual:
 * /declaracion-renta/empresario-individual/:anio/:tarjeta. Busca la tarjeta en la lista
 * de ese año (EmpresarioIndividual/registry.js) y muestra su componente; así cada
 * tarjeta nueva no necesita otra ruta. «Volver al panel» regresa al panel del mismo año.
 */
const TarjetaEmpresarioIndividualPage = () => {
    const navigate = useNavigate();
    const { anio, tarjeta: idTarjeta } = useParams();
    const { selectedCompany } = useAuth();
    const idCompany = selectedCompany?.id_company || selectedCompany?.id;
    const anioTributario = Number(anio);
    const tarjeta = getTarjeta(anioTributario, idTarjeta);
    const Componente = tarjeta && !tarjeta.enConstruccion ? tarjeta.componente : null;

    return (
        <div className="tarjeta-ei-page">
            <div className="tarjeta-ei-header">
                <div>
                    <h1>{tarjeta ? tarjeta.titulo : 'Tarjeta'}</h1>
                    <p>{tarjeta ? `${tarjeta.fuente} · ` : ''}Renta AT {anioTributario} · empresario individual</p>
                </div>
                <button className="tarjeta-ei-volver" onClick={() => navigate(`/declaracion-renta?anio=${anioTributario}`)}>
                    <FaArrowLeft /> Volver al panel
                </button>
            </div>

            {Componente
                ? <Componente anioTributario={anioTributario} idCompany={idCompany} />
                : (
                    <p className="tarjeta-ei-aviso">
                        {tarjeta
                            ? 'Este módulo aún está en construcción.'
                            : `TAXI aún no tiene la tarjeta «${idTarjeta}» del AT ${anioTributario}.`}
                    </p>
                )}
        </div>
    );
};

export default TarjetaEmpresarioIndividualPage;
